module.exports = __webpack_public_path__ + "img/best-jazz.8cdd84e9.png";